import { Pipe, PipeTransform } from "@angular/core";
import {TranslocoService} from "@ngneat/transloco";
import {transformValueAndCurrency} from "../utility/currency-helper";
import {getCurrencySymbol} from "@angular/common";


@Pipe({
    name: "myCurrency",
    standalone: false
})
export class CurrencyPipe implements PipeTransform {

  constructor(private transloco: TranslocoService) {
  }

  transform = (value: number | string | undefined, currencyLabel = "",
               symbol: boolean = false,
               fractionSize = 2): string => {
    return transformValueAndCurrency(value, this.transloco.getActiveLang(), currencyLabel, fractionSize, symbol,
      symbol ? getCurrencySymbol(currencyLabel, "wide") : '');
  }
}
